import { getDataToCancel } from "features/orders/components/orders-cancel/utils";
import Fetch from "utils/fetch";

export const getMaterialSupplierSettings = (idFamiliaRotuladaCentro) => {
  return Fetch.get(`masterdata/material-supplier-settings/stock-detail/${idFamiliaRotuladaCentro}`).then(({ data }) => data)
}

export const searchTransfers = async (idFamiliaRotuladaCentro, query) => {
  return Fetch.get(`shelfLife/consultarExistenciaTransferencias/${idFamiliaRotuladaCentro}${query}`).then(({ data }) => data)
}

export const searchChartData = (idFamiliaRotulada, model) => {
  return Fetch.post(`/visaoEstoque/consultaVisaoEstoqueCardDetalheGrafico/${idFamiliaRotulada}`, model).then(({ data }) => data)
}

export const searchVariableStockPolicy = (idFamiliaRotuladaCentro) => {
  return Fetch.get(`/visaoEstoque/obterPoliticaEstoqueVariavel/${idFamiliaRotuladaCentro}`).then(({ data }) => data);
}

export const searchCardDetail = (idFamiliaRotulada, query) => {
  return Fetch.get(`/visaoEstoque/consultaVisaoEstoqueCardDetalhe/${idFamiliaRotulada}${query}`).then(({ data }) => data);
}

export const searchSuggestionExplanation = (suggestionId) => {
  return Fetch.get(`/suggestions/${suggestionId}:explanation`).then(({ data }) => data);
}

export const checkSuggestionInconsistencies = (idUser, idFamiliaRotuladaCentro, materials) => {
  return Fetch.post(`/sugestoes/verificarInconsistenciasDaSugestao/${idUser}/${idFamiliaRotuladaCentro}`, { Sugestoes: materials }).then(({ data }) => data);
}

export const searchJustificationsRequestOnOver = () => {
  return Fetch.get(`/sugestoes/listaJustificativasPedidoEmOver`).then(({ data }) => data);
}

export const acceptSuggestions = (idUser, idFamiliaRotuladaCentro, justificativasPedidoEmOverOption, sugestaoGeraEstoqueOverOuMaxmimaEstoque, suggestions, overCapacity, stockReturn ) => {
  const body = {
    UserId: idUser,
    LabeledFamilyCenterId: idFamiliaRotuladaCentro,
    OrderInOverOrMaxStock: sugestaoGeraEstoqueOverOuMaxmimaEstoque,
    OrderInOverJustificationType: justificativasPedidoEmOverOption,
    Suggestions: suggestions,
    Overcapacity: overCapacity,
    ...(stockReturn ? { stockReturn } : {}),
  }
  return Fetch.post('suggestions:accept', body);
}

export const acceptExternalSuggestions = (idUser, idFamiliaRotuladaCentro, justificativasPedidoEmOverOption, sugestaoGeraEstoqueOverOuMaxmimaEstoque, materials) => {
  const suggestion = {
    IdSuggestion: materials,
    UserId: idUser,
    LabeledFamilyCenterId: idFamiliaRotuladaCentro,
    JustificationTypeOverOrder: justificativasPedidoEmOverOption,
    OverOrderOrMaximumStock: sugestaoGeraEstoqueOverOuMaxmimaEstoque
  }
  return Fetch.post(`/suggestions/external-data:accept`, suggestion);
}

export const changeRequest = (alteracaoPedido) => {
  return Fetch.post(`/pedido/alterarPedidoVisaoEstoqueDetalhe`, alteracaoPedido).then(({ data }) => data);
}

export const saveSuggestion = (sugestao, isExternalSuggestion) => {
  const build = {
    model: sugestao,
    method: 'post',
    url: '/suggestions:update'
  }

  if (isExternalSuggestion) {
    build.model = {
      Id: sugestao.Id,
      BusinessUnitId: sugestao.IdUnidadeNegocio,
      MaterialId: sugestao.IdMaterial,
      SupplierId: sugestao.IdFornecedor,
      PortOfLoadingId: sugestao.PortOfLoadingId,
      PortOfDischargeId: sugestao.PortOfDischargeId,
      Quantity: sugestao.QuantidadeSugeridaAte,
      DeliveryDate: sugestao.EntregaAte,
      DeliveryHour: sugestao.HoraEntrega,
      PickUpDate: sugestao.DataColeta,
      Priority: sugestao.PrioridadeXadrez,
      Incoterm: sugestao.ResponsavelEntrega,
      Notes: sugestao.Observacao,
      TaxCode: sugestao.CodigoImposto,
      BuyerGroup: sugestao.GrupoCompradores,
      PurchasingOrganization: sugestao.OrganizacaoCompras,
      ManualJustification: sugestao.TipoJustificativaSugestaoManual,
      DocumentType: sugestao.DocumentType,
      RequirementCode: sugestao.RequirementCode,
      BusinessUnitStorageLocationId: sugestao.BusinessUnitStorageLocationId
    }
    build.url = 'suggestions/external-data/manual'
    build.method = sugestao.Id ? 'put' : 'post'
  }

  return Fetch[build.method](build.url, build.model)
}

export const deleteSuggestion = (idFamiliaRotuladaCentro, sugestoes, isExternalSuggestion) => {
  const build = {
    url: isExternalSuggestion ? `suggestions/external-data/manual:delete`
      : `/suggestions:remove`,

    body: isExternalSuggestion ? { Id: sugestoes } : { Sugestoes: sugestoes }
  }

  return isExternalSuggestion ? Fetch.post(build.url, build.body) : Fetch.delete(build.url, build.body)
}

export const cancelBalance = (idItemVolume, body) => {
  return Fetch.post(`/volume-orders/${idItemVolume}:cancel`, body);
}

export const newManualSuggestion = async (idFamiliaRotuladaCentro, query) => {
  return Fetch.get(`/sugestoes/criarNovaSugestaoManual/${idFamiliaRotuladaCentro}${query}`).then(({ data }) => data);
}

export const cancelOrder = (order, forcedCancel, note) => {
  const request = getDataToCancel(order, forcedCancel, note);
  return Fetch.post(request.API, request.body);
}

export const applyProgrammingInStock = (idFamiliaRotuladaCentro) => {
  return Fetch.post(`/visaoEstoque/aplicarProgramacaoNoEstoque/${idFamiliaRotuladaCentro}`);
}

export const saveOverviewStockInformation = async (visaoEstoqueInformacoes) => {
  return Fetch.post(`/visaoEstoque/salvarVisaoEstoqueInformacoes/`, visaoEstoqueInformacoes).then(() => Promise.resolve());
}

export const createSuggestionByShelfLife = async (idFamiliaRotuladaCentro, itemsShelfLifeCheckedData) => {
  return Fetch.post(`shelfLife/criarSugestaoViaShelfLife/${idFamiliaRotuladaCentro}`, itemsShelfLifeCheckedData).then(() => Promise.resolve());
}

export const composicaoCargaCancel = (loadCompositionId, cancelamento) => {
  return Fetch.post(`/load-compositions/${loadCompositionId}:cancel`, cancelamento);
}

export const lastUpdateOfStock = (idFamiliaRotuladaCentro) => {
  return Fetch.get(`/visaoEstoque/obterUltimaAtualizacao/${idFamiliaRotuladaCentro}`).then(({ data }) => data);
}

export const fetchEstoqueCompartilhado = (labeledFamilyCenterId) => {
  return Fetch.get(`/shared-stocks:by-labeled-family-center?labeledFamilyCenterId=${labeledFamilyCenterId}`).then(({ data }) => data);
}

export const fetchExternalWarehouses = async (query) => {
  return Fetch.get(`/business-units:external-warehouses-stocks?${query}`).then(({ data }) => data);
}

export const fetchConsigneeStock = async (idFamiliaRotuladaCentro) => {
  return Fetch.get(`/visaoEstoque/consultaEstoqueConsignado/${idFamiliaRotuladaCentro}`)
    .then(({ data }) => data);
}

export const fetchConsigneeStockCurve = (idFamiliaRotuladaCentro, from, to) => {
  const query = new URLSearchParams({ from, to }).toString();

  return Fetch.get(`/visaoEstoque/consultaCurvaEstoqueConsignado/${idFamiliaRotuladaCentro}?${query}`)
    .then(({ data }) => data);
}

export const fetchCurrentStockReturns = (labeledFamilyCenterId) => (
  Fetch.get(`/stock-returns?labeledFamilyCenterId=${labeledFamilyCenterId}&view=current`)
    .then(({ data }) => data)
)

export const finishStockReturns = (stockReturnIds) => (
  Fetch.post("/stock-returns:finish", { stockReturnIds })
    .then(({ data }) => data)
)

export const cancelStockReturn = (stockReturnId) => (
  Fetch.post(`/stock-returns/${stockReturnId}:cancel`)
)

export const requestOrderCancellation = (requestOrderCancellationDto) => {
  return Fetch.put(`/pedido/requestOrderCancellation`, requestOrderCancellationDto).then(({ data }) => data);
}

export const confirmCancellationAwaitingCheck = (idPedido) => {
  return Fetch.put(`/pedido/ConfirmCancellationAwaitingCheck/${idPedido}`).then(({ data }) => data);
}

export const getAllEstoqueATG = (idFamiliaRotuladaCentro) => (
  Fetch.get(`/estoqueAtivoGiro/obterEstoqueMaterialAtgPorFamiliaRotuladaCentro/${idFamiliaRotuladaCentro}`).then(({ data }) => data)
)

export const getAllLinkedBreweryOnExternalWarehouse = (query) => {
  return Fetch.get(`business-units/${query.businessUnitId}/breweries?labeledFamilyId=${query.labeledFamilyId}`).then(({ data }) => data)
}

export const getAllLinkedExternalWarehouseOnBrewery = (query) => 
  Fetch.get(`business-units/${query.businessUnitId}/external-warehouses?labeledFamilyId=${query.labeledFamilyId}`).then(({ data }) => data)

export const searchPorts = () => 
  Fetch.get('international-ports').then(({ data }) => data);
